"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CreateMode;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactSound = _interopRequireDefault(require("react-sound"));

var _LobbyRaceGenderWindow = _interopRequireDefault(require("../../../../windows/lobby/LobbyRaceGenderWindow/LobbyRaceGenderWindow"));

var _LobbyClassWindow = _interopRequireDefault(require("../../../../windows/lobby/LobbyClassWindow/LobbyClassWindow"));

var _LobbyShapeWindow = _interopRequireDefault(require("../../../../windows/lobby/LobbyShapeWindow/LobbyShapeWindow"));

var _LobbyStatusWindow = _interopRequireDefault(require("../../../../windows/lobby/LobbyStatusWindow/LobbyStatusWindow"));

var _LobbyDescriptionWindow = _interopRequireDefault(require("../../../../windows/lobby/LobbyDescriptionWindow/LobbyDescriptionWindow"));

var _LobbyNameWindow = _interopRequireDefault(require("../../../../windows/lobby/LobbyNameWindow/LobbyNameWindow"));

var _LobbyCreateCharacterFigure = _interopRequireDefault(require("./components/LobbyCreateCharacterFigure/LobbyCreateCharacterFigure"));

var _LobbyHometownMapWindow = _interopRequireDefault(require("../../../../windows/lobby/LobbyHometownMapWindow/LobbyHometownMapWindow"));

var _CreateModeModule = _interopRequireDefault(require("./CreateMode.module.scss"));

var _Controls = _interopRequireDefault(require("./components/Controls/Controls"));

var _assets = require("../../../../../assets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function CreateMode(_ref) {
  var onCancel = _ref.onCancel,
      onSubmit = _ref.onSubmit;

  var _useState = (0, _react.useState)(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      raceId = _useState2[0],
      setRaceId = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      allowedCharacterClassIds = _useState4[0],
      setAllowedCharacterClassIds = _useState4[1];

  var _useState5 = (0, _react.useState)("female"),
      _useState6 = _slicedToArray(_useState5, 2),
      gender = _useState6[0],
      setGender = _useState6[1];

  var _useState7 = (0, _react.useState)(""),
      _useState8 = _slicedToArray(_useState7, 2),
      name = _useState8[0],
      setName = _useState8[1];

  var _useState9 = (0, _react.useState)(""),
      _useState10 = _slicedToArray(_useState9, 2),
      classId = _useState10[0],
      setClassId = _useState10[1];

  var _useState11 = (0, _react.useState)(""),
      _useState12 = _slicedToArray(_useState11, 2),
      soundSrc = _useState12[0],
      setSoundSrc = _useState12[1];

  var _useState13 = (0, _react.useState)("STOPPED"),
      _useState14 = _slicedToArray(_useState13, 2),
      soundStatus = _useState14[0],
      setSoundStatus = _useState14[1];

  var _useState15 = (0, _react.useState)(0),
      _useState16 = _slicedToArray(_useState15, 2),
      soundPos = _useState16[0],
      setSoundPos = _useState16[1];

  var playShoutSound = (0, _react.useCallback)(function () {
    if (!raceId) return;
    var filename = "".concat(raceId, "_").concat(gender.slice(0, 1), "_shout03.wav");
    var soundUrl = "".concat(_assets.ASSETS_RACES, "/sounds/").concat(raceId, "/").concat(filename);
    setSoundSrc(soundUrl);
    setSoundStatus("STOPPED");
    setSoundPos(0);
    setSoundStatus("PLAYING");
  }, [gender, raceId]);
  var onChangeGender = (0, _react.useCallback)(function (value) {
    setGender(value);
  }, []);
  var onChangeRace = (0, _react.useCallback)(function (characterRaceId) {
    setRaceId(characterRaceId);
    setClassId("");

    switch (characterRaceId) {
      case "barbarian":
        setAllowedCharacterClassIds(["warrior", "knight", "paladin", "archer"]);
        break;

      case "highelf":
        setAllowedCharacterClassIds(["archer", "wizard", "cleric", "summoner"]);
        break;

      case "woodelf":
        setAllowedCharacterClassIds(["warrior", "archer", "wizard", "summoner"]);
        break;

      default:
        throw new Error();
    }
  }, []);
  var onChangeClass = (0, _react.useCallback)(function (characterClassId) {
    setClassId(characterClassId);
  }, []);
  var onNext = (0, _react.useCallback)(function () {
    if (onSubmit) console.error("TODO", onSubmit, name, gender, raceId, classId);
    /*
            check if all stat points are allocated
            check if class has been chosen
            races_slide_out();
            classes_slide_out();
            shapes_slide_out();
            status_slide_out();
            map_slide_in()
        */
  }, [onSubmit, name, gender, raceId, classId]);
  var onBack = (0, _react.useCallback)(function () {
    if (onCancel) onCancel();
    /*
    TODO
            $('#create_btn_next').removeAttr('onclick');
            $('#view_create').fadeOut('slow', function() {
                $('#view_seats').fadeIn('slow',function() {
                    create_reset();
                });
            });
        */

    /*
        // slide off map
        map_slide_out();
        // remove onclick handler
        $('#create_btn_back').removeAttr('onclick');
        $('#create_btn_next').removeAttr('onclick');
         setTimeout(function() {
            races_slide_in();
            classes_slide_in();
            shapes_slide_in();
            status_slide_in();
            // add new onclick handler to buttons
            $('#create_btn_back').attr('onclick','create_cancel();');
            $('#create_btn_next').attr('onclick','create_continue();');
        }, 1000);
        */
  }, [onCancel]);
  (0, _react.useEffect)(function () {
    playShoutSound();
  }, [raceId, gender, playShoutSound]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _CreateModeModule.default.createMode
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _CreateModeModule.default.windows
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _CreateModeModule.default.raceGenderAndClassWindow
  }, /*#__PURE__*/_react.default.createElement(_LobbyRaceGenderWindow.default, {
    className: _CreateModeModule.default.raceGenderWindow,
    onChangeRace: onChangeRace,
    onChangeGender: onChangeGender
  }), /*#__PURE__*/_react.default.createElement(_LobbyClassWindow.default, {
    className: (0, _classnames.default)(_CreateModeModule.default.classWindow, raceId === undefined && _CreateModeModule.default.isHidden),
    selectedCharacterClassId: classId,
    allowedCharacterClassIds: allowedCharacterClassIds,
    onChange: onChangeClass
  })), /*#__PURE__*/_react.default.createElement(_LobbyShapeWindow.default, {
    className: (0, _classnames.default)(_CreateModeModule.default.shapeWindow, raceId === undefined && _CreateModeModule.default.isHidden)
  }), /*#__PURE__*/_react.default.createElement(_LobbyStatusWindow.default, {
    className: (0, _classnames.default)(_CreateModeModule.default.statusWindow, raceId === undefined && _CreateModeModule.default.isHidden)
  }), /*#__PURE__*/_react.default.createElement(_LobbyDescriptionWindow.default, {
    className: _CreateModeModule.default.descriptionWindow,
    raceId: raceId,
    classId: classId
  }), /*#__PURE__*/_react.default.createElement(_LobbyHometownMapWindow.default, {
    className: _CreateModeModule.default.mapWindow
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _CreateModeModule.default.nameAndFigure
  }, /*#__PURE__*/_react.default.createElement(_LobbyNameWindow.default, {
    className: _CreateModeModule.default.nameWindow,
    onChange: setName
  }), /*#__PURE__*/_react.default.createElement(_LobbyCreateCharacterFigure.default, {
    className: _CreateModeModule.default.createFigure,
    raceId: raceId,
    gender: gender
  }), /*#__PURE__*/_react.default.createElement(_Controls.default, {
    className: _CreateModeModule.default.controls,
    onNext: onNext,
    onBack: onBack
  })), /*#__PURE__*/_react.default.createElement(_reactSound.default, {
    key: soundSrc,
    url: soundSrc,
    position: soundPos,
    volume: 100,
    playStatus: soundStatus,
    onFinishedPlaying: function onFinishedPlaying() {
      return setSoundStatus("STOPPED");
    }
  }));
}